import About from "../about.vue";
import Faqs from "../faqs.vue";
import Account from "../platform-pages/account.vue";
import Announcement from "../platform-pages/announcement.vue";
import Application from "../platform-pages/application.vue";
import AssetGroup from "../platform-pages/asset-group.vue";
import DataBreach from "../platform-pages/data-breach.vue";
import FileManager from "../platform-pages/file-manager.vue";
import Hierarchy from "../platform-pages/hierarchy.vue";
import Inventory from "../platform-pages/inventory.vue";
import LegalDocument from "../platform-pages/legal-document.vue";
import OrganizationMembers from "../platform-pages/organization-members.vue";
import OrganizationSettings from "../platform-pages/organization-settings.vue";
import Policy from "../platform-pages/policy.vue";
import Questionset from "../platform-pages/questionset.vue";
import Report from "../platform-pages/report.vue";
import Risk from "../platform-pages/risk.vue";
import Roadmap from "../platform-pages/roadmap.vue";
import Screen from "../platform-pages/screen.vue";
import Task from "../platform-pages/task.vue";
import Thirdparty from "../platform-pages/thirdparty.vue";
import Platform from "../platform.vue";
import Support from "../support.vue";

export const helpCenter = {
  routes: [
    {
      path: "/help-center/about",
      component: About,
    },
    {
      path: "/help-center",
      component: About,
    },
    {
      path: "/help-center/faqs",
      component: Faqs,
    },

    {
      path: "/help-center/support",
      component: Support,
    },
    {
      path: "/help-center/platform",
      component: Platform,
    },

    {
      path: "/help-center/platform/screen-panel",
      component: Screen,
    },

    {
      path: "/help-center/platform/account-info",
      component: Account,
    },

    {
      path: "/help-center/platform/roadmap",
      component: Roadmap,
    },

    {
      path: "/help-center/platform/announcement",
      component: Announcement,
    },
    {
      path: "/help-center/platform/organization-settings",
      component: OrganizationSettings,
    },
    {
      path: "/help-center/platform/organization-members",
      component: OrganizationMembers,
    },
    {
      path: "/help-center/platform/thirdparty",
      component: Thirdparty,
    },
    {
      path: "/help-center/platform/application",
      component: Application,
    },
    {
      path: "/help-center/platform/hierarchy",
      component: Hierarchy,
    },
    {
      path: "/help-center/platform/asset-group",
      component: AssetGroup,
    },
    {
      path: "/help-center/platform/inventory",
      component: Inventory,
    },
    {
      path: "/help-center/platform/data-breach",
      component: DataBreach,
    },
    {
      path: "/help-center/platform/risk",
      component: Risk,
    },
    {
      path: "/help-center/platform/policy",
      component: Policy,
    },
    {
      path: "/help-center/platform/task",
      component: Task,
    },
    {
      path: "/help-center/platform/questionset-survey",
      component: Questionset,
    },
    {
      path: "/help-center/platform/legal-document",
      component: LegalDocument,
    },
    {
      path: "/help-center/platform/report",
      component: Report,
    },
    {
      path: "/help-center/platform/file-manager",
      component: FileManager,
    },
  ],
};
